module.exports = __webpack_public_path__ + "static/media/comune_monfalcone.9e0097fc.png";